import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";

import GlobalImage from "../../../../global/image/image";
import LikeProperty from "../../../../global/like-property";
import StarRating from "../../../../global/star-rating/StarRating";
import NoImage from "../../../../../assets/image_not_supported.svg";
import { replaceImageUrlSize } from "../../../../../utils/image";
import UserInputViewer from "../../../../global/UserInputViewer";

import "./styles.css";

const PropertyDetails = ({ property, isLoading, params, setAvailableProperties, likePropertyId, isActivateByHover = false }) => {
  const getElements = () => {
    const preElement = document.querySelector(`.advance-marker[data-property-id='${property.id}']`);
    const element = document.querySelector(`.map-marker[data-property-id='${property.id}']`);
    const imgElement = document.querySelector(`.marker-img[hover-img-id='${property.id}']`);
    return { element, imgElement, preElement };
  };

  const mouseOver = () => {
    if (!isActivateByHover) return;

    const { element, imgElement, preElement } = getElements();
    if (element && imgElement && preElement) {
      element.classList.add("animate");
      imgElement.classList.add("animate");
      preElement.classList.add("marker-hover");
    }
  };

  const mouseLeave = () => {
    const { element, imgElement, preElement } = getElements();

    if (element && imgElement && preElement) {
      element.classList.remove("animate");
      imgElement.classList.remove("animate");
      preElement.classList.remove("marker-hover");
    }
  };

  const navigateURL = `/property/${property?.id}/${property?.name}`;

  return (
    <Link
      to={navigateURL}
      className="property-details-modal"
      onMouseOver={mouseOver}
      onMouseLeave={mouseLeave}
      style={{
        // opacity: isLoading ? 0.4 : 1,
        overflowY: isLoading ? "hidden" : "auto",
      }}
      target="_blank"
    >
      <div className="property-image-isliked">
        {property?.defaultImage ? (
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={replaceImageUrlSize(property?.defaultImage, "medium")}
              alt="Building"
              className="building skeleton-loading"
            />
            <GlobalImage
              src={replaceImageUrlSize(property?.defaultImage, "square")}
              alt="Building"
              className="property-details-modal-img "
              loading="lazy"
            />
          </picture>
        ) : (
          <img
            src={NoImage}
            alt="Not Available"
            className="building"
            onLoad={(e) => {
              e.target.classList.remove("skeleton-loading");
            }}
          />
        )}
        <div
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          className="like-property-icon"
        >
          <LikeProperty
            propertyId={likePropertyId}
            isLiked={property?.isLiked}
            handleLike={(propertyId, liked) => {
              setAvailableProperties((prev) => {
                return prev.map((property) => {
                  if (property.id === propertyId) {
                    return { ...property, isLiked: !liked };
                  }
                  return property;
                });
              });
            }}
          />
        </div>
      </div>
      <div className="property-details">
        <div className="property-details-name-reviews">
          <UserInputViewer tag="h4" className="property-name" text={property.name} />
          {property?.reviewSummary.reviewerCount > 0 && (
            <div className="property-details-reviews">
              <div className="reviews-over-all-score">{property?.reviewSummary.overallScore.toFixed(1)}</div>
              <div className="review-count">
                {property?.reviewSummary.reviewerCount} review
                {property?.reviewSummary.reviewerCount > 1 && "s"}
              </div>
            </div>
          )}
        </div>
        <UserInputViewer tag="address" text={property?.address} className="property-address-distination-map" />
        <StarRating rating={property?.rating} />
      </div>
    </Link>
  );
};

export default PropertyDetails;
